import React, { FC } from 'react'
import SendIcon from '../../../public/static/icons/form-sended.svg'
import css from './Sended.module.scss'

const Sended: FC<{ heading: string; subheading: string }> = ({
  heading,
  subheading,
}) => {
  return (
    <div className={css.send_wrapper}>
      <SendIcon />
      <h4 className={css.send_heading}>{heading}</h4>
      <p className={css.send_description}>{subheading}</p>
    </div>
  )
}

export default Sended
